<sc-headroom upTolerance="5" downTolerance="5" innerClassName="sc-header" [class.scrolled]="scrolled">
  <div class="container-fluid">
    <nav #nav class="sc-nav">
      <a class="sc-logo me-auto">
        <app-svg-logo></app-svg-logo>
      </a>
    </nav>
  </div>
</sc-headroom>